var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "High Function Sports Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('sub-product', {
    attrs: {
      "tit": "High Function Sports Line",
      "file": "sports"
    }
  }, [_vm._v(" Moisture-repellent/proof, Cooling/Heating function helps consumer lives a healthy life. These functions starts with high-quality yarn and construction of fabric. Discover a variety of silhouettes and fabrications that enrich your life. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }